import React from "react";
import { Instagram, Linkedin, Mail } from "lucide-react";
import { withUtm } from "@/components/danone/utm";
import CeliaContactPopover from "@/components/danone/CeliaContactPopover";
import orangeBusinessLogo from "@/assets/orange-business-logo.png.asset.json";

const DanoneFooter = () => {
  return (
    <footer className="bg-white py-4 px-4">
      <div className="max-w-[1126px] mx-auto">
        <div className="flex items-center justify-between gap-4 md:gap-6 border-b border-[rgba(0,0,0,0.1)] pb-4">
          <div>
            <img
              src={orangeBusinessLogo.url}
              alt="Orange Business Logo"
              className="h-auto w-[120px] md:w-[150px]"
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-7 flex-wrap mt-4">
          <div className="flex-1 flex flex-col md:flex-row md:items-center gap-3 md:gap-7 flex-wrap text-xs md:text-sm text-gray-500">
            <span>© SAS NABOO GROUP 2025</span>
            <a href={withUtm("https://www.naboo.app/fr-fr/terms-of-use")} className="hover:text-gray-700">
              Conditions générales d'utilisation
            </a>
            <a href={withUtm("https://www.naboo.app/fr-fr/privacy-policy")} className="hover:text-gray-700">
              CGU
            </a>
            <CeliaContactPopover align="start">
              <button type="button" className="hover:text-gray-700 text-left">
                Contactez-nous
              </button>
            </CeliaContactPopover>
            <a href="#" className="hover:text-gray-700">
              Modifier vos préférences de cookies
            </a>
          </div>
          <div className="flex gap-4 mt-2 md:mt-0">
            <a
              href={withUtm("https://www.linkedin.com/company/naboo-app/posts/?feedView=all")}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <Linkedin size={20} />
            </a>
            <a
              href={withUtm("https://www.instagram.com/naboo_app/")}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <Instagram size={20} />
            </a>
            <CeliaContactPopover align="end">
              <button
                type="button"
                aria-label="Email"
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                <Mail size={20} />
              </button>
            </CeliaContactPopover>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DanoneFooter;
